import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, throwError, from, switchMap, EMPTY } from 'rxjs';
import { LocalStorageWrapper } from '../classes/local-storage-wrapper.class';
import { AuthSubscriptionService } from '../services/auth-subscription.service';
import { FormatDateService } from '../services/format-date.service';
import { IAuthenticationService } from '../interfaces/authentication-service.interface';
import { AuthenticationService_TOKEN } from '../tokens/injection-tokens';

@Injectable({
    providedIn: 'root',
})
export class HttpErrorHandlerService implements HttpInterceptor {
    constructor(
        private injector: Injector,
        private router: Router
    ) {}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                console.log('HTTPErrorHandlerService');
                console.log(error);
                console.log(this.router.url);
                if (
                    error.status != 504 &&
                    error.status != 500 &&
                    error.status != 401 &&
                    error.status != 400 &&
                    error.status != 0
                ) {
                    const formatDateService = this.injector.get(FormatDateService);
                    const errorMessage = `${JSON.stringify(error)} - ${formatDateService.formatDateTime(new Date())}`;
                    alert('HttpErrorHandlerService - ' + errorMessage);
                }

                if (error.status === 401 && this.router.url !== '/authentication/login') {
                    const authenticationService =
                        this.injector.get<IAuthenticationService>(AuthenticationService_TOKEN);

                    return from(authenticationService.tryRefreshingTokens()).pipe(
                        switchMap(refreshSucceeded => {
                            if (refreshSucceeded) {
                                const authSubscriptionService = this.injector.get(AuthSubscriptionService);

                                authSubscriptionService.sendAuthStateChangeNotification(true);
                                req = req.clone({
                                    setHeaders: {
                                        Authorization: `Bearer ${LocalStorageWrapper.getToken()}`,
                                    },
                                });
                                return next.handle(req);
                            } else {
                                authenticationService.logout();
                                return EMPTY;
                            }
                        })
                    );
                }
                return throwError(() => error);
            })
        );
    }
}
